(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_vusi-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vusi-product-gallery')) {
  customElements.define('vusi-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-media-zoom]');
        const dialog = this.querySelector('dialog');
        if (zoom && this.dataset.zoom === 'true') {
          const original = zoom.querySelector('img');
          if (!original || !dialog) return;
          const copy = original.cloneNode(true);
          copy.removeAttribute('sizes');
          copy.setAttribute('sizes', '100vw');
          this.querySelector('.vusi-product-gallery__expanded').replaceChildren(copy);
          this.returnFocus = zoom;
          dialog.showModal();
        }
        if (event.target.closest('[data-close]')) dialog?.close();
        const play = event.target.closest('[data-video-toggle]');
        if (play) {
          const video = play.parentElement.querySelector('video');
          if (video.paused) video.play().catch(() => {}); else video.pause();
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const tile = event.target.closest('.vusi-product-media');
        if (tile && matchMedia('(max-width:749px)').matches) tile.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'});
      }, options);
      this.frame = requestAnimationFrame(() => {
        this.querySelector('dialog')?.addEventListener('close', () => {
          this.querySelector('.vusi-product-gallery__expanded').replaceChildren();
          this.returnFocus?.focus({preventScroll:true});
        }, options);
        this.motion = matchMedia('(prefers-reduced-motion:reduce)');
        const updateMotion = () => {
          this.querySelectorAll('video[data-auto="true"]').forEach(v => {
            if (this.motion.matches) v.pause();
            else if (!this.observer || this.visibleVideos?.has(v)) v.play().catch(() => {});
          });
        };
        this.motion.addEventListener('change', updateMotion, options);
        this.visibleVideos = new Set();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
              this.visibleVideos.add(video);
              if (video.dataset.auto === 'true' && !this.motion.matches) video.play().catch(() => {});
            } else { this.visibleVideos.delete(video); video.pause(); }
          }), {threshold:.15});
        }
        const mobileStartup = matchMedia('(max-width:749px)').matches;
        if (mobileStartup && 'IntersectionObserver' in window) {
          this.warmObserver = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.preload = 'auto';
            this.warmObserver.unobserve(entry.target);
          }), { root: this.querySelector('.vusi-product-gallery__track'), rootMargin: '0px 100%', threshold: 0 });
        }
        this.querySelectorAll('video').forEach((video, index) => {
          this.warmObserver?.observe(video);
          if (mobileStartup && index > 0 && video.poster && !video.dataset.firstFrameShown) {
            const cover = document.createElement('img');
            cover.className = 'vusi-product-media__startup';
            cover.src = video.poster;
            cover.alt = '';
            cover.setAttribute('aria-hidden', 'true');
            video.after(cover);
            let frameId = null, paintId = null;
            const reveal = () => {
              paintId = requestAnimationFrame(() => {
                video.dataset.firstFrameShown = 'true';
                cover.remove();
              });
            };
            if ('requestVideoFrameCallback' in video) {
              const onFrame = () => {
                if (!video.paused && video.currentTime > 0) reveal();
                else frameId = video.requestVideoFrameCallback(onFrame);
              };
              frameId = video.requestVideoFrameCallback(onFrame);
            } else {
              video.addEventListener('playing', () => {
                paintId = requestAnimationFrame(() => {
                  if (video.readyState >= 2) reveal();
                });
              }, { ...options, once: true });
            }
            this.abort.signal.addEventListener('abort', () => {
              if (frameId !== null) video.cancelVideoFrameCallback?.(frameId);
              if (paintId !== null) cancelAnimationFrame(paintId);
              cover.remove();
            }, { once: true });
          }

          this.observer?.observe(video);
          const button = video.parentElement.querySelector('[data-video-toggle]');
          const update = () => { if (button) { button.textContent = video.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label',video.paused ? button.dataset.playLabel : button.dataset.pauseLabel); } };
          video.addEventListener('play',update,options);
          video.addEventListener('pause',update,options);
          update();
        });
        updateMotion();
        this.startGlide(options);
      });
    }
    startGlide(options) {
      const track = this.querySelector('.vusi-product-gallery__track');
      const timeline = this.querySelector('[data-timeline]');
      const fill = timeline.querySelector('span');
      const mobile = matchMedia('(max-width:749px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let touching = false, resumeAt = 0, previous = 0, position = track.scrollLeft, direction = 1, visible = false, startAt = null;
      this.glidePaused = false;
      const pause = () => { resumeAt = performance.now() + 4000; position = track.scrollLeft; };
      track.addEventListener('pointerdown', () => { touching = true; pause(); }, options);
      window.addEventListener('pointerup', () => { touching = false; pause(); }, options);
      window.addEventListener('pointercancel', () => { touching = false; pause(); }, options);
      track.addEventListener('wheel', pause, {...options, passive:true});
      track.addEventListener('keydown', pause, options);
      this.addEventListener('shopify:block:select', () => { this.glidePaused = true; }, options);
      this.glideObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:.1});
      this.glideObserver.observe(this);
      const tick = now => {
        const dt = Math.min((now - (previous || now)) / 1000, .05); previous = now;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        if (startAt === null && visible && mobile.matches && !document.hidden) startAt = now + 3000;
        const paused = startAt === null || now < startAt || touching || now < resumeAt || this.glidePaused || document.hidden || !visible || reduced.matches || !mobile.matches || this.querySelector('dialog[open]') || track.contains(document.activeElement);
        if (paused) position = track.scrollLeft;
        else if (max > 0 && this.dataset.glide !== 'false') {
          position += direction * Number(this.dataset.speed || 18) * dt;
          if (position >= max) { position = max; direction = -1; resumeAt = now + 3000; }
          if (position <= 0) { position = 0; direction = 1; resumeAt = now + 3000; }
          track.scrollLeft = position;
        }
        timeline.hidden = !mobile.matches || max < 1;
        fill.style.transform = `translateX(${max ? track.scrollLeft / max * 300 : 0}%)`;
        this.glideFrame = requestAnimationFrame(tick);
      };
      this.glideFrame = requestAnimationFrame(tick);
    }

    disconnectedCallback() { cancelAnimationFrame(this.frame); cancelAnimationFrame(this.glideFrame); this.glideObserver?.disconnect(); this.warmObserver?.disconnect(); this.abort?.abort(); this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
